var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAffirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.167,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.301 11.97h-1.108v-.436c0-.566.323-.728.602-.728.308 0 .547.137.547.137l.378-.863s-.383-.25-1.079-.25c-.782 0-1.672.44-1.672 1.824v.315h-1.856v-.435c0-.566.323-.728.602-.728.158 0 .371.037.548.137l.377-.863c-.225-.133-.587-.25-1.078-.25-.782 0-1.672.44-1.672 1.824v.315h-.71v.944h.71v3.336h1.223v-3.336h1.856v3.336h1.224v-3.336H15.3v-.944zm-8.93 3.51c-.32 0-.481-.157-.481-.418 0-.483.54-.649 1.527-.753 0 .646-.436 1.172-1.045 1.172zm.426-3.637c-.705 0-1.516.333-1.957.684l.403.847c.353-.324.924-.6 1.44-.6.489 0 .76.164.76.493 0 .222-.18.334-.519.378-1.264.165-2.257.514-2.257 1.489 0 .773.55 1.24 1.41 1.24.614 0 1.16-.34 1.42-.79v.665H8.64v-2.787c0-1.151-.8-1.619-1.843-1.619zm11.484.126v4.28h1.224v-2.062c0-.98.593-1.268 1.007-1.268.161 0 .38.047.523.154l.223-1.131a1.398 1.398 0 0 0-.548-.099c-.63 0-1.025.28-1.286.845v-.719H18.28zm7.27.626c.251-.369.735-.752 1.382-.752.782 0 1.43.486 1.43 1.448v2.958h-1.224v-2.571c0-.567-.34-.802-.664-.802-.405 0-.81.37-.81 1.17v2.203h-1.223v-2.563c0-.584-.321-.81-.671-.81-.387 0-.8.379-.8 1.17v2.203h-1.225v-4.28h1.18v.647c.206-.413.654-.772 1.301-.772.593 0 1.09.274 1.323.751zm-8.297 3.654h-1.222v-4.28h1.222v4.28z",
    fill: "#060809"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.16 6c-3.303 0-6.248 2.293-7.084 5.242h1.198c.698-2.196 3.067-4.123 5.886-4.123 3.427 0 6.388 2.608 6.388 6.67 0 .911-.118 1.733-.341 2.46h1.161l.012-.04c.19-.75.287-1.563.287-2.42 0-4.53-3.3-7.789-7.507-7.789z",
    fill: "#0FA0EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.167,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    stroke: "#F5F5FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAffirm);
export default __webpack_public_path__ + "static/media/affirm.440ab592d5b42a05b21638d78363bcca.svg";
export { ForwardRef as ReactComponent };